import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.46875 9.83154C2.46875 5.5063 5.97505 2 10.3003 2C14.6255 2 18.1318 5.5063 18.1318 9.83154C18.1318 11.6622 17.5037 13.3461 16.4513 14.6795L22.4688 20.697L21.1658 22L15.1483 15.9825C13.8148 17.035 12.1309 17.6631 10.3003 17.6631C5.97505 17.6631 2.46875 14.1568 2.46875 9.83154ZM10.3003 3.84271C6.99275 3.84271 4.31146 6.524 4.31146 9.83154C4.31146 13.1391 6.99275 15.8204 10.3003 15.8204C13.6078 15.8204 16.2891 13.1391 16.2891 9.83154C16.2891 6.524 13.6078 3.84271 10.3003 3.84271Z",
		fill: "#395566"
	})
});
export default SvgLine;
